import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Receipt16Regular } from "@fluentui/react-icons";
import { RootState } from "../../../redux/store";
import ASCButton from "../../../components/Button";
import { checkUserPermission, convertStringToArray } from "../../../utils";
import { UserPermissionsList } from "../../../config";
import { StopReceiptPopUp } from "../case/StopReceiptPopUp";

type Props = {
  selectedItem: any;
  notify: any;
  onStopped: () => void;
};

// "Stop Receipts" for a client Fee/Charge, shown under the same rules as the
// case Commission tab: a receipting fee (status 1), the receipting permission
// and the stop_commission_receipts env flags.
function FeesStopReceiptsButton({ selectedItem, notify, onStopped }: Props) {
  const loggedUser = useSelector((state: RootState) => state.authUser);
  const [open, setOpen] = useState(false);

  if (
    selectedItem?.status != 1 ||
    !checkUserPermission(
      loggedUser,
      UserPermissionsList.ALLOW_COMMISSION_RECEIPTING,
    ) ||
    convertStringToArray(process.env.REACT_APP_HIDE_CTA_BUTTON).includes(
      "stop_commission_receipts",
    )
  ) {
    return null;
  }

  return (
    <>
      <ASCButton
        shape="rounded"
        style={{ marginRight: 2, marginBottom: 6 }}
        icon={<Receipt16Regular />}
        size="medium"
        onClick={() => setOpen(true)}
        label="Stop Receipts"
        disabled={convertStringToArray(
          process.env.REACT_APP_DISABLE_CTA_BUTTON,
        ).includes("stop_commission_receipts")}
      />
      {open && (
        <StopReceiptPopUp
          openModal={open}
          selectedItem={selectedItem}
          notify={notify}
          setStopReceiptPopup={setOpen}
          getCommissionDataList={onStopped}
        />
      )}
    </>
  );
}

export default FeesStopReceiptsButton;
